import axios from "axios";

export type UnsubscribeService = {
  unsubscribeEmailNotifications: (args: { p: string, s: string }) => Promise<unknown>;
  fetchStatus: (args: { p: string, s: string }) => Promise<boolean>;
};

// Every notification email type exposes the same backend unsubscribe pair
// (see src/misc/unsubscribeRoutes.js) — one factory instead of a service file
// per type. The next email type is one line here.
const makeUnsubscribeService = (path: string): UnsubscribeService => ({
  async unsubscribeEmailNotifications({ p, s }: { p: string, s: string }): Promise<unknown> {
    const response = await axios.post(`/api/organizations/superadmin/${path}/unsubscribe/${p}/${s}`);
    return response.data;
  },
  async fetchStatus({ p, s }: { p: string, s: string }): Promise<boolean> {
    const response = await axios.get(`/api/organizations/superadmin/${path}/unsubscribe/status/${p}/${s}`);
    return response.data.status;
  },
});

export const ServiceBidReceived = makeUnsubscribeService("bid-received");
export const ServiceIntentReceived = makeUnsubscribeService("intent-received");
export const ServiceMessageDigest = makeUnsubscribeService("message-digest");
